
import Vue from 'vue';
import { ModalActions, ModalTitle, Button } from '@descomplica/vue-components';
import { CourseModel } from '@descomplica/dex-models';

export default Vue.extend({
  components: {
    ModalTitle,
    ModalActions,
    Button,
  },
  props: {
    defaultMonthsOption: {
      required: true,
      type: Number,
    },
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    contractExpirationDate(): string {
      return this.$store.getters
        .studyPlanning(this.currentCourse.id)
        ?.contractExpirationDate.toLocaleDateString('pt-br');
    },
    defaultMonthsOptionLabel(): string {
      return `${this.defaultMonthsOption} ${this.$tc(
        'postgradStudyPlanningConfigModalMonth',
        this.defaultMonthsOption,
      )}`;
    },
  },
  methods: {
    closeDefaultStudyPlanningModal(): void {
      this.$emit('setupFinished');
    },
  },
});
